import { has } from 'lodash';
import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

/**
 *
 * @param {Object} params
 * @param {String} actionType
 * @return {function(*)}
 * @private
 */
const _getManyLearningAssets = (params, actionType) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/learningassets`;
    const url = buildQueryString(rest, baseUrl);
    return (dispatch) => {
        dispatch({
            type: ACTIONS.GET_MANY_LEARNING_ASSETS_START
        });
        return VerbFetch(url).then((body) => {
            dispatch({
                type: actionType,
                payload: {
                    learningAssets: body
                }
            });
            return body;
        });
    };
};

/**
 *
 * @param {Object} query
 * @return {function(*)}
 */
export const getFilteredLearningAssets = (query) => _getManyLearningAssets(query, ACTIONS.GET_FILTERED_LEARNING_ASSETS);

/**
 *
 * @param {Object} params
 * @return {function(*)}
 */
export const getManyLearningAssets = (params) => _getManyLearningAssets(params, ACTIONS.GET_MANY_LEARNING_ASSETS);

export const getLearningAsset = (params) => {
    const { learningAssetId, getFullProjection = false, dispatchDisabled, isSample = false, pathsContext } = params;
    const baseUrl = `${pathsContext.serverUrl}/learningassets/${learningAssetId}`;
    const url = buildQueryString({ getFullProjection, isSample }, baseUrl);
    if (dispatchDisabled) {
        return VerbFetch(url);
    }
    return (dispatch) =>
        VerbFetch(url).then((body) => {
            dispatch({
                type: ACTIONS.GET_LEARNING_ASSET,
                payload: {
                    learningAsset: body
                }
            });

            return body;
        });
};

export const getLearningAssetsWithUserSubscriptionCount = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.adminServerUrl}/learningassets/subscriptioncount`;
    const url = buildQueryString(rest, baseUrl);
    return VerbFetch(url).then((body) => body);
};

export const postLearningAsset = (params) => {
    const { body, pathsContext } = params;

    if (has(body, 'testEmailAddress')) {
        delete body.testEmailAddress;
    }

    return (dispatch) => {
        dispatch({
            type: ACTIONS.POST_LEARNING_ASSET_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/learningassets`, {
            method: 'POST',
            body
        }).then((body) => {
            dispatch({
                type: ACTIONS.POST_LEARNING_ASSET_SUCCESS,
                payload: {
                    learningAsset: body
                }
            });
            return body;
        });
    };
};

export const putLearningAsset = (params) => {
    const { learningAssetId, body, pathsContext } = params;

    if (has(body, 'testEmailAddress')) {
        delete body.testEmailAddress;
    }

    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_LEARNING_ASSET_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/learningassets/${learningAssetId}`, {
            method: 'PUT',
            body
        }).then((body) => {
            dispatch({
                type: ACTIONS.PUT_LEARNING_ASSET_SUCCESS,
                payload: {
                    learningAsset: body
                }
            });
            return body;
        });
    };
};

export const updateLearningAssetArchiveStatus = (params) => {
    const { learningAsset, isArchived, pathsContext } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_LEARNING_ASSET_START,
            payload: {
                learningAsset
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/learningassets/${learningAsset._id}/archive`, {
            method: 'PUT',
            body: { isArchived }
        }).then((body) => {
            dispatch({
                type: ACTIONS.PUT_ARCHIVED_LEARNING_ASSET_SUCCESS,
                payload: {
                    learningAsset: body
                }
            });
            return body;
        });
    };
};

export const getArchivedLearningAssets = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.adminServerUrl}/learningassets/archived`;
    const url = buildQueryString(rest, baseUrl);

    return (dispatch) =>
        VerbFetch(url).then((body) => {
            dispatch({
                type: ACTIONS.GET_MANY_ARCHIVED_LEARNING_ASSETS,
                payload: {
                    learningAssets: body
                }
            });
            return body;
        });
};

export const getInitialLearningAssetsForExplore = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/learningassets/exploresearch`;
    const url = buildQueryString(rest, baseUrl);

    return (dispatch) => 
      VerbFetch(url, {
      method: 'GET'
      })
      .then((result) => { 
        dispatch({
            type: ACTIONS.GET_MANY_LEARNING_ASSETS,
            payload: {
                learningAssets: result.learningAssets
            }
        });
        return result; 
      }).catch((err) => {
          console.error(err);
      });
};

export const getUserAccessibleLearningAssetsForExplore = (params) => {
    const { pathsContext } = params;
    return VerbFetch(`${pathsContext.serverUrl}/learningassets/userexploresearch`, {
        method: 'GET'
    })
        .then((result) => result)
        .catch((err) => {
            console.error(err);
        });
};

export const getLearningAssetStatus = (learningAssetId, query) => {
    const { pathsContext, ...rest } = query;
    const baseUrl = `${pathsContext.adminServerUrl}/learningassets/${learningAssetId}/status`;
    const url = buildQueryString(rest, baseUrl);
    return VerbFetch(url, {
        method: 'GET'
    })
        .then((result) => result)
        .catch((err) => {
            console.error(err);
            return { error: true };
        });
};

export const getManageLearningAssetsTableData = (query) => {
    const { pathsContext, ...rest } = query;
    const baseUrl = `${pathsContext.adminServerUrl}/learningassets/managetabledata`;
    const url = buildQueryString(rest, baseUrl);
    return VerbFetch(url)
        .then((body) => body)
        .catch((err) => {
            console.error(err);
            return { error: true };
        });
};

export const getManyLearningAssetsAssociatedCollections = (pathsContext, learningAssetIds) =>
    VerbFetch(`${pathsContext.adminServerUrl}/learningassets/associatedcollections`, {
        method: 'POST',
        body: { learningAssetIds }
    })
        .then((result) => result)
        .catch((err) => {
            console.error(err);
            return { error: true };
        });

export const clearSearchedLearningAssets = () => (dispatch) =>
    dispatch({
        type: ACTIONS.CLEAR_SEARCHED_LEARNING_ASSETS
    });

export const getPastLearningAssets = (params) => {
    const { pathsContext, learningAssetId } = params;
    const url = `${pathsContext.adminServerUrl}/learningassets/${learningAssetId}/versions`;
    return VerbFetch(url).then((result) => result);
};
